import { render, staticRenderFns } from "./MedicalExpenseLimit.vue?vue&type=template&id=03af6638"
import script from "./MedicalExpenseLimit.vue?vue&type=script&lang=js"
export * from "./MedicalExpenseLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports